<app-olps-temperatur *ngIf="widget === 'olps-temperature-dm1'"
                 [resizeEvent]="resizeEvent"
                 [Temp]="Thing?.propertySets?.get('TEMPERATUR')?.properties.get('DM1_MOTOR')"
                 [Type]="'Fahrmotor 1'">
</app-olps-temperatur>

<app-olps-temperatur *ngIf="widget === 'olps-temperature-dm2'"
                     [resizeEvent]="resizeEvent"
                     [Temp]="Thing?.propertySets?.get('TEMPERATUR')?.properties.get('DM2_MOTOR')"
                     [Type]="'Fahrmotor 2'">
</app-olps-temperatur>

<app-olps-temperatur *ngIf="widget === 'olps-temperature-dm4'"
                     [resizeEvent]="resizeEvent"
                     [Temp]="Thing?.propertySets?.get('TEMPERATUR')?.properties.get('DM4_MOTOR')"
                     [Type]="'Hubmotor 1'">
</app-olps-temperatur>

<app-olps-temperatur *ngIf="widget === 'olps-temperature-dm5'"
                     [resizeEvent]="resizeEvent"
                     [Temp]="Thing?.propertySets?.get('TEMPERATUR')?.properties.get('DM5_MOTOR')"
                     [Type]="'Hubmotor 2'">
</app-olps-temperatur>

<app-olps-temperatur *ngIf="widget === 'olps-temperature-cap'"
                     [resizeEvent]="resizeEvent"
                     [Temp]="Thing?.propertySets?.get('TEMPERATUR')?.properties.get('CAPACITOR')"
                     [Type]="'Kondensator'">
</app-olps-temperatur>

<app-image *ngIf="widget === 'image'"
           [resizeEvent]="resizeEvent"
           [heading]="'Darstellung OLPS' | translate"
           [src]="Thing.model3D"
           [equipmentNumber]="Thing.equipmentNumber"
           [alt]="'Darstellung OLPS' | translate"
           [ain]="Thing.ainUrl"
           [width]="'auto'">
</app-image>

<app-olps-distance *ngIf="widget === 'olps-distance'"
                   [resizeEvent]="resizeEvent"
                   [Distance]="Thing.propertySets.get('DISTANCE')">
</app-olps-distance>

<app-olps-capacitor *ngIf="widget === 'olps-capacitor'"
                    [resizeEvent]="resizeEvent"
                    [Capacitor]="Thing.propertySets.get('CAPACITOR')">
</app-olps-capacitor>

<app-olps-charge-time *ngIf="widget === 'olps-charge-time'"
                      [resizeEvent]="resizeEvent"
                      [Capacitor]="Thing.propertySets.get('CAPACITOR')">
</app-olps-charge-time>

<app-olps-orders *ngIf="widget === 'olps-orders'"
                 [resizeEvent]="resizeEvent"
                 [Orders]="Thing.propertySets.get('ORDERS')"
                 [Movements]="Thing.propertySets.get('MOVEMENTS')">
</app-olps-orders>

<app-time *ngIf="widget === 'time'"
          [resizeEvent]="resizeEvent"
          [TimeGeneral]="Thing.propertySets.get('TIME_GENERAL')">
</app-time>

<app-olps-positioning *ngIf="widget === 'olps-positioning'"
                      [resizeEvent]="resizeEvent"
                      [Position]="Thing.propertySets.get('POSITION')">
</app-olps-positioning>

<app-cm-sensors *ngIf="widget === 'cm-mdw'"
                [resizeEvent]="resizeEvent"
                [Type]="''"
                [Environment]="Thing.propertySets.get('DRR_ENV')"
                [Rotation]="Thing.propertySets.get('DRR_ROT')"
                [AngularVelocity]="Thing.propertySets.get('DRR_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('DRR_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cm-mdw-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="''"
                    [Environment]="Thing.propertySets.get('DRR_ENV')"
                    [Sound]="Thing.propertySets.get('DRR_SOUND')"
                    [AngularVelocity]="Thing.propertySets.get('DRR_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('DRR_ACL')">
</app-cm-sensors-two>
